export const INITIAL_LAST_ID = 0;

export function normalizeLastId(lastId) {
  return lastId === null || lastId === undefined || lastId === ""
    ? INITIAL_LAST_ID
    : lastId;
}
